import { graphql } from '../../generated';

export const LIST_FRAGMENT = graphql(`
  fragment TicketListFragment on ScannerCodes {
    list(first: 300, after: $cursor, updatedSince: $updatedSince) {
      nodes {
        id
        personalIdentifier
        seat {
          name
          row
          id
          venueSection {
            name
          }
        }
        validatedBy
        usedAt
        validationCode
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`);

export const SCANNER_EVENT_QUERY = graphql(`
  query ScannerEvent($secureEventId: ID!) {
    event(id: $secureEventId) {
      id
      sku
      artist
      name
      happeningFrom
      stageTime
      venue {
        name
        address {
          address
          address2
          city
        }
      }
      scannerCodeTypes
      salesStats {
        sold
      }
    }
  }
`);

export const DELETED_FRAGMENT = graphql(`
  fragment DeletedTicketsFragment on ScannerCodes {
    deleted(updatedSince: $updatedSince) {
      id
    }
  }
`);

export const SCANNER_CODES = graphql(`
  query ScannerCodes($secureEventId: ID!, $cursor: String, $updatedSince: ISO8601DateTime) {
    scannerCodes(secureEventId: $secureEventId) {
      ...TicketListFragment
    }
  }
`);

export const SCANNER_CODES_WITH_DELETED = graphql(`
  query ScannerCodesWithDeleted($secureEventId: ID!, $cursor: String, $updatedSince: ISO8601DateTime!) {
    scannerCodes(secureEventId: $secureEventId) {
      ...TicketListFragment
      ...DeletedTicketsFragment
    }
  }
`);

export const UPDATE_TICKETS = graphql(`
  mutation UpdateTickets($secureEventId: ID!, $ticketUpdates: [TicketUpdate!]!) {
    updateTicketValidation(input: { secureEventId: $secureEventId, ticketUpdates: $ticketUpdates }) {
      clientMutationId
    }
  }
`);
